import { useRecoilState } from 'recoil'
import articleSearchTagsAtom from '../../../../searchTags.atom'
import SearchInput from '../../../../../../../../../shared/Inputs/SearchInput'

const ArticleSearchTagsFilters = () => {
  const [articleSearchTagsState, setArticleSearchTagsState] = useRecoilState(articleSearchTagsAtom)

  const handleChange = (value: any, name: string) => {
    setArticleSearchTagsState((prev) => ({ ...prev, filters: { ...prev.filters, [name]: value } }))
  }

  return (
    <div className='inline-flex-gap' style={{ width: '100%', gap: '8px' }}>
      <SearchInput
        value={articleSearchTagsState.filters.search}
        name='search'
        onChange={handleChange}
        required={false}
        placeholder='Отфильтровать'
        autofocus={true}
      />
    </div>
  )
}

export default ArticleSearchTagsFilters
